import Rectangle from "./Rectangle";
import Length from "./Length";
import AbstractShape from "./AbstractShape";
import Area from "./Area";

export default class QuarterCircle extends AbstractShape {
	static NAME = "quarter-circle";

	constructor( radius ) {
		super();

		this.radius = radius;
	}

	get_name() {
		return QuarterCircle.NAME;
	}

	get_area() {
		const area = Math.PI * Math.pow( this.radius.in_mm(), 2 );
		return new Area( 0.25 * area );
	}

	get_circumference() {
		const diameter = this.radius.multiply( 2 ).in_mm();
		const circle_circumference = new Length( Math.PI * diameter );

		return new Length( 0.25 * circle_circumference.in_mm() + diameter );
	}

	get_enclosing_rectangle() {
		return new Rectangle( this.radius, this.radius );
	}

	get_maximum_dimensions( maximum_rectangle ) //Because a quarter circle only uses half of a plate a circle uses we should
	//double the maximum diameter.
	{
		const shortest_side = maximum_rectangle.get_shortest_side();
		return {
			radius: shortest_side
		};
	}

	get_dimension_keys() {
		return ["radius"];
	}

	get_modifier_keys() {
		return [];
	}

	serialize_primitives() {
		return {
			radius: this.radius.in_mm()
		};
	}

	static deserialize_primitives( primitives )	{
		return new this( new Length( primitives.radius ) );
	}
}
